import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import DisciplinaryActionsServices from "./disciplinary_actions.services";
import errorManage from "../../errorManage";
import gestorDocumentalServices from "../../gestorDocumental/gestorDocumental.services";
import DisciplinaryCaseServices from "../diciplinarycase/disciplinary_case.services";
import WFlowEmpleadosServices from "../../on&offBoarning/Mantenimientos/WorkFlowEmp/wFlowEmpleados.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getDisciplinaryActions = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTIONS,
      payload: true,
    });
    const resp = await DisciplinaryActionsServices.getDisciplinaryActions(
      filters
    );
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTIONS,
      payload: {
        disciplinaryActions: resp.data.data,
        disciplinaryActionsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.DISCIPLINARY_ACTIONS_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.EMAIL_ERROR,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.DISCIPLINARY_ACTIONS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTIONS,
      payload: false,
    });
  }
};

export const saveDisciplinaryActions = (data, emailArray, reqWF, medidadDis, dCase, dataGD, setRespSelected,setTempSelected,setCatSelected,setMedSelected,setCaseSelected,setMedidadDis,close) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_DISCIPLINARY_ACTIONS,
        payload: true,
      });
      if(medidadDis && dCase && dCase.list_id_usuario){
        const _reqWF = await WFlowEmpleadosServices.saveWorkFlowEmp(reqWF);
        if(_reqWF && _reqWF.data && _reqWF.data.resultado && _reqWF.data.resultado.length>0){
          data.off_bording = _reqWF.data.resultado[0].workflow;
        }
      }
      const resp = await DisciplinaryActionsServices.saveDisciplinaryActions(data);
      dataGD.id_registro=resp.data.id;
      let _respuesta = {}
      if(medidadDis){
        const respGD = await gestorDocumentalServices.saveDocument(dataGD);
        data.archivo_autorizacion = respGD.data.resultado.id;
        _respuesta = await DisciplinaryActionsServices.editDisciplinaryActions(
          resp.data.id,
          {
            ...resp.data,
            archivo_autorizacion: respGD.data.resultado.id,
          }
        );
      }else{
        _respuesta = await DisciplinaryActionsServices.editDisciplinaryActions(resp.data.id,resp.data);
      }
      const { disciplinaryActions, disciplinaryActionsLength } = getState().disciplinaryActions;
      let _resp = _respuesta.data;
      const aDisciplinaryActions = [...disciplinaryActions, _resp];
      dispatch({
        type: actions.GET_DISCIPLINARY_ACTIONS,
        payload: {
          disciplinaryActions: aDisciplinaryActions,
          disciplinaryActionsLength: disciplinaryActionsLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setRespSelected([]);
      setTempSelected([]);
      setCatSelected([]);
      setMedSelected([]);
      setCaseSelected([]);
      setMedidadDis(false);
      close();
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      // if (emailArray && emailArray.length > 0) {
      //   let _emailArray = [];
      //   emailArray.map((mail) => {
      //     const _mail = {
      //       accion_disciplinaria: _resp.id,
      //       correo: mail,
      //       tipo_mensaje:"Correo manual-Accion disciplinaria"
      //     };
      //     _emailArray.push(_mail)
      //   });
      //   // dispatch(emailSend({data:_emailArray}));
      //   await DisciplinaryCaseServices.envioCorreo({data:_emailArray});
      // }
      if (emailArray && emailArray.length > 0) {
        let _emailArray = [];
        emailArray.map((mail) => {
          _emailArray.push({
            // caso_disciplinario_id: _resp.caso_disciplinario,
            accion_disciplinaria: _resp.id,
            correo: mail,
            tipo_mensaje:"Correo manual-Accion disciplinaria"
          })
        });
        await DisciplinaryCaseServices.envioCorreo({data:_emailArray});
      }
      const _data = {
        data:[
          {
            caso_disciplinario_id:resp.data.caso_disciplinario,
            tipo_mensaje:"Jefe empleado-Accion disciplinaria"
          },
          {
            caso_disciplinario_id:resp.data.caso_disciplinario,
            tipo_mensaje:"Jefe responsable sanciones-Accion disciplinaria"
          },
          {
            caso_disciplinario_id:resp.data.caso_disciplinario,
            tipo_mensaje:"Encargado caso-Accion disciplinaria"
          }
        ]
      }
      await DisciplinaryCaseServices.envioCorreo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              if(ex.response && ex.response.data && ex.response.data.mensaje){
                message = messages.errorMessage + " " + ex.response.data.mensaje;
              }else if(ex.response && ex.response.data && ex.response.data.resultado && ex.response.data.resultado.length > 0){
                  message = messages.errorMessage + " " + ex.response.data.resultado[0].response;
              }else{
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_DISCIPLINARY_ACTIONS,
        payload: false,
      });
    }
  };

export const editDisciplinaryActions = (data, editItem, index, emailArray,reqWF, medidadDis, dCase, dataGD, setRespSelected,setTempSelected,setCatSelected,setMedSelected,setCaseSelected,setMedidadDis,close, docSubir) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_DISCIPLINARY_ACTIONS,
        payload: true,
      });
      if(editItem.off_bording === null && medidadDis && dCase && dCase.list_id_usuario){
        const _reqWF = await WFlowEmpleadosServices.saveWorkFlowEmp(reqWF);
        if(_reqWF && _reqWF.data && _reqWF.data.resultado && _reqWF.data.resultado.length>0){
          data.off_bording = _reqWF.data.resultado[0].workflow;
        }
      }
      let resp = {};
      if(medidadDis && docSubir.length > 0){
        let respGD = {}
        if(editItem.archivo_autorizacion){
          respGD = await gestorDocumentalServices.editDocument(editItem.archivo_autorizacion, dataGD);
          data.archivo_autorizacion = respGD.data.resultado.id;
        }else{
          respGD = await gestorDocumentalServices.saveDocument(dataGD);
          data.archivo_autorizacion = respGD.data.resultado.id;
        }
      }
      resp = await DisciplinaryActionsServices.editDisciplinaryActions(editItem.id,data);
      const { disciplinaryActions, disciplinaryActionsLength } = getState().disciplinaryActions;
      disciplinaryActions[index] = resp.data;
      dispatch({
        type: actions.GET_DISCIPLINARY_ACTIONS,
        payload: {
          disciplinaryActions: disciplinaryActions,
          disciplinaryActionsLength: disciplinaryActionsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setRespSelected([]);
      setTempSelected([]);
      setCatSelected([]);
      setMedSelected([]);
      setCaseSelected([]);
      setMedidadDis(false);
      close();
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      // if (emailArray && emailArray.length > 0) {
      //   let _emailArray = [];
      //   emailArray.map((mail) => {
      //     const _mail = {
      //       accion_disciplinaria: editItem.id,
      //       correo: mail,
      //       tipo_mensaje:"Correo manual-Accion disciplinaria"
      //     };
      //     _emailArray.push(_mail)
      //   });
      //   // dispatch(emailSend({data:_emailArray}));
      //   await DisciplinaryCaseServices.envioCorreo({data:_emailArray});
      // }
      if (emailArray && emailArray.length > 0) {
        let _emailArray = [];
        emailArray.map((mail) => {
          _emailArray.push({
            // caso_disciplinario_id: editItem.caso_disciplinario,
            accion_disciplinaria: editItem.id,
            correo: mail,
            tipo_mensaje:"Correo manual-Accion disciplinaria"
          })
        });
        await DisciplinaryCaseServices.envioCorreo({data:_emailArray});
        toastr.success(messages.correoEnviado, '', {
          progressBar: true,
          rtl: true,
        });
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              if(ex.response && ex.response.data && ex.response.data.mensaje){
                message = messages.errorMessage + " " + ex.response.data.mensaje;
              }else if(ex.response && ex.response.data && ex.response.data.resultado && ex.response.data.resultado.length > 0){
                message = ex.response.data.resultado[0].resultado;
              }else{
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_DISCIPLINARY_ACTIONS,
        payload: false,
      });
    }
  };

export const deleteDisciplinaryActions = (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_DISCIPLINARY_ACTIONS,
        payload: true,
      });
      await DisciplinaryActionsServices.deleteDisciplinaryActions(id);
      const { disciplinaryActions, disciplinaryActionsLength } = getState().disciplinaryActions;
      disciplinaryActions.splice(index, 1);
      dispatch({
        type: actions.GET_DISCIPLINARY_ACTIONS,
        payload: {
          disciplinaryActions: disciplinaryActions,
          disciplinaryActionsLength: disciplinaryActionsLength - 1,
        },
      });
      dispatch({
        type: actions.DISCIPLINARY_ACTIONS_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.DISCIPLINARY_ACTIONS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_DISCIPLINARY_ACTIONS,
        payload: false,
      });
    }
  };

export const saveDisciplinaryActionDocGD = (dataGD, editItem, index, iType, exist) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_DISCIPLINARY_ACTIONS,
        payload: true,
      });
      const { disciplinaryActions, disciplinaryActionsLength } = getState().disciplinaryActions;
      if (exist) {
        const respGD = await gestorDocumentalServices.saveDocument(dataGD);
        const resp = await DisciplinaryActionsServices.editDisciplinaryActions(
          editItem.id,
          {
            ...editItem,
            archivo_evidencia: respGD.data.resultado.id,
          }
        );
        disciplinaryActions[index] = resp.data;
        dispatch({
          type: actions.GET_DISCIPLINARY_ACTIONS,
          payload: {
            disciplinaryActions: disciplinaryActions,
            disciplinaryActionsLength: disciplinaryActionsLength,
          },
        });
      } else {
        dispatch({
          type: actions.GET_DISCIPLINARY_ACTIONS,
          payload: {
            disciplinaryActions: disciplinaryActions,
            disciplinaryActionsLength: disciplinaryActionsLength,
          },
        });
      }
      toastr.success(messages.successMessage);
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.LOADING_DISCIPLINARY_ACTIONS,
        payload: false,
      });
    }
  };

export const editDisciplinaryActionDocGD = (dataGD, editItem, index, iType, arGD, exist) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_DISCIPLINARY_ACTIONS,
        payload: true,
      });
      const { disciplinaryActions, disciplinaryActionsLength } = getState().disciplinaryActions;
      if (exist) {
        const respGD = await gestorDocumentalServices.editDocument(
          arGD,
          dataGD
        );
        const resp = await DisciplinaryActionsServices.editDisciplinaryActions(
          editItem.id,
          {
            ...editItem,
            archivo_evidencia: respGD.data.id,
          }
        );
        disciplinaryActions[index] = resp.data;
        dispatch({
          type: actions.GET_DISCIPLINARY_ACTIONS,
          payload: {
            disciplinaryActions: disciplinaryActions,
            disciplinaryActionsLength: disciplinaryActionsLength,
          },
        });
        toastr.success(messages.successMessage);
      } else {
        dispatch({
          type: actions.GET_DISCIPLINARY_ACTIONS,
          payload: {
            disciplinaryActions: disciplinaryActions,
            disciplinaryActionsLength: disciplinaryActionsLength,
          },
        });
      }
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.LOADING_DISCIPLINARY_ACTIONS,
        payload: false,
      });
    }
  };

export const emailSend = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMAIL_SEND,
      payload: true,
    });
    await DisciplinaryActionsServices.emailSend(data);
    dispatch({
      type: actions.EMAIL_ERROR,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EMAIL_ERROR,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMAIL_SEND,
      payload: false,
    });
  }
};
